import { render, staticRenderFns } from "./playerDetail_inforPanel.vue?vue&type=template&id=ebd0f730&scoped=true"
import script from "./playerDetail_inforPanel.vue?vue&type=script&lang=js"
export * from "./playerDetail_inforPanel.vue?vue&type=script&lang=js"
import style0 from "./playerDetail_inforPanel.vue?vue&type=style&index=0&id=ebd0f730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd0f730",
  null
  
)

export default component.exports